import { PM_API_RESOURCES } from '../constants'

import { isInitializedRequestForPMResource } from './requestStateSelectors'

export const didFetProjectSummaries = state => {
  return isInitializedRequestForPMResource(state, PM_API_RESOURCES.ALL_PROJECT_SUMMARIES)
}
